<template>
	<div>
		<div class="container">
		<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Postavke profila</h3>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 salon-container mb-3">
					<div class="col-12">
						<notify></notify>
					</div>
					<div class="container mb-3">
						<div class="row no-gutters">
							<div class="col-12">
								<table class="table table-hover table-borderless bizInfoTable">
									<tr>
										<th>Korisničko ime:<span class="required">*</span></th>
										<td class="bizInfoInput"><input type="text" v-model="user.name" placeholder="Unesite korisničko ime"></td>
										<!-- <td class="bizInfoLink">uredi</td> -->
									</tr>
									<tr>
										<th>E-adresa:<span class="required">*</span></th>
										<td class="bizInfoInput"><input type="text" :value="user.email" disabled='true'></td>
										<!-- <td class="bizInfoLink">uredi</td> -->
									</tr>
									<tr>
										<th>Kontakt:<span class="required">*</span></th>
										<td class="bizInfoInput"><input type="text" v-model="user.contact" placeholder="Unesite kontakt broj"></td>
										<!-- <td class="bizInfoLink">uredi</td> -->
									</tr>
									<!-- <tr>
                                        <th>Adresa:<span class="required">*</span></th>
                                        <td class="bizInfoInput"><input type="text" v-model="user.address"  placeholder="--click to edit your address--"></td>
                                        <td class="bizInfoLink">uredi</td>
                                    </tr> -->
									<!--<tr>
										<th>Receive Notification Via:<span class="required">*</span></th>
										<th>
											<div style='display: flex;justify-content: space-around;'>
												<label for="wt">
													<input id="wt" :checked="user.receive_notification == 'whatsapp'" type="radio" name="notif" @change="toggleNotification('whatsapp')"> &nbsp; Whatsapp
												</label>
												<label for="em">
													<input id="em" :checked="user.receive_notification == 'email'" type="radio" name="notif" @change="toggleNotification('email')">&nbsp; E-Mail
												</label>
											</div>
										</th>
									</tr>
									<tr>
										<th>Obavijesti:<span class="required">*</span></th>
										<td class="bizInfoInput"><input type="text" v-model="user.whatsapp" placeholder="--click to edit your whatsapp contact--"></td>
										<td class="bizInfoLink">uredi</td>
									</tr> -->

									<br><br>
									<b>Promijeni lozinku</b>
									<tr>
										<th>Trenutna lozinka:<span class="required">*</span></th>
										<td class="bizInfoInput"><input type="password" v-model="current_password" placeholder="Unesite trenutnu lozinku"></td>
										<!-- <td class="bizInfoLink">uredi</td> -->
									</tr>
									<tr>
										<th>Nova lozinka:<span class="required">*</span></th>
										<td class="bizInfoInput"><input type="password" v-model="password" placeholder="Unesite novu lozinku"></td>
										<!-- <td class="bizInfoLink">uredi</td> -->
									</tr>
									<tr>
										<th>Potvrdi novu lozinku:<span class="required">*</span></th>
										<td class="bizInfoInput"><input type="password" v-model="password_confirmation" placeholder="Potvrdite novu lozinku"></td>
										<!-- <td class="bizInfoLink">uredi</td> -->
									</tr>
								</table>
								<button @click="save()" class="btn fs-btn dark">
									<span v-if="!loader">Ažuriraj profil</span>
									<loader v-else color='red'></loader>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: "profile",
		computed: {
			...mapState({
				user: (state) => state.user,
				// loader:(state)=>state.loader,
				endpoint: (state) => state.endpoint,
				token: (state) => state.token,
			})
		},
		data() {
			return {
				loader: false,
				password: '',
				current_password: '',
				password_confirmation: ''
			}
		},
		created() {
			// console.log(this.user);
		},
		methods: {
			/*
			toggleNotification(value) {
				this.$store.state.user.receive_notification = value;
			},*/
			save() {
				if (this.loader) {
					return false;
				}

				if (this.user.name.length == 0 || this.user.email.length == 0) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Molimo Vas ispunite sva obavezna polja.'
					})
					return false;
				}

				if (this.password.length > 0) {
					if (this.password != this.password_confirmation) {
						this.$store.commit('setNotification', {
							type: 2,
							msg: "Lozinka za potvrdu nije ista kao i nova lozinka."
						})
						return false;
					}
					if (this.current_password.length == 0) {
						this.$store.commit('setNotification', {
							type: 2,
							msg: "Unesite trenutnu lozinku kako biste je promijenili."
						})
						return false;
					}
				}

				this.loader = true;
				let payload = {
					name: this.user.name,
					contact: this.user.contact,
					whatsapp: this.user.whatsapp,
					address: this.user.address,
					receive_notification: this.user.receive_notification,
					password: this.password,
					current_password: this.current_password,
				};
				this.$store.dispatch('post', {
						details: payload,
						endpoint: this.endpoint + 'update-user?token=' + this.token
					})
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.$store.state.user = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						} else {
							this.$store.commit('setNotification', {
								type: 2,
								msg: data.data.message
							});
						}
						this.loader = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
						this.loader = false;
					})
			},
		},
	}

</script>
